var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2925 1.39903C9.93394 1.5584 9.55543 1.65801 9.157 1.71777C9.55543 1.47872 9.87418 1.10021 10.0136 0.642014C9.63512 0.86115 9.21677 1.02052 8.75857 1.12013C8.39999 0.741621 7.88203 0.502563 7.32423 0.502563C6.24847 0.502563 5.37193 1.37911 5.37193 2.45487C5.37193 2.61424 5.39185 2.75369 5.43169 2.89314C3.81805 2.81345 2.36378 2.03652 1.38763 0.841228C1.22826 1.14005 1.12865 1.45879 1.12865 1.81738C1.12865 2.49471 1.46732 3.09235 2.0052 3.45094C1.68645 3.43102 1.38763 3.35133 1.10873 3.21188V3.2318C1.10873 4.18803 1.78606 4.98489 2.68253 5.16419C2.52316 5.20403 2.34386 5.22395 2.16457 5.22395C2.04504 5.22395 1.90559 5.20403 1.78606 5.18411C2.04504 5.96104 2.76221 6.53877 3.61884 6.53877C2.94151 7.05673 2.10481 7.37547 1.18842 7.37547C1.02905 7.37547 0.869675 7.37547 0.730225 7.35555C1.60677 7.91335 2.62276 8.23209 3.73837 8.23209C7.34415 8.23209 9.31637 5.24387 9.31637 2.65408C9.31637 2.5744 9.31637 2.47479 9.31637 2.3951C9.69488 2.13612 10.0335 1.79746 10.2925 1.39903Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a7bb8098cb0acd16d215c337f751f670.svg";
export { ForwardRef as ReactComponent };